"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import Pencil  from "./Pencil";
import InkPot  from "./InkPot";
import Brush  from "./Brush";
import Spray  from "./Spray";
import Stamp from "./Stamp";
import Eraser from "./Eraser";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function DrawLayer() {
    PIXI.Container.call(this);


    // States.
    this.STATE = {
        IDLE: 0,
        DRAWING: 1
    };


    // Attributes.
    this._state = this.STATE.IDLE;

    this._canvas2d = null;
    this._context = null;

    // TEST: DYN_OUT:
    this._dynOutline_c2d = null;
    this._dynOutlineContext = null;
    this._dynOutlineLayerData = null;

    this._pencil = null;
    this._brush = null;
    this._spray = null;
    this._stamp = null;
    this._inkPot = null;
    this._drawingTool = null;
    this._eraser = null;

    this._drawPS = null;

    // Sprites.
    this._layerSprite = null;

    // Input.
    this._lastInputLocalPosition = new PIXI.Point();
    this._updateInputLocalPosition = new PIXI.Point();
}
export default DrawLayer;
//module.exports = DrawLayer;
DrawLayer.prototype = Object.create(PIXI.Container.prototype);
DrawLayer.prototype.constructor = DrawLayer;


//===================================================
//
// Public
//
//===================================================

DrawLayer.prototype.init = function () {
    // Canvas.
    this._canvas2d = document.createElement('canvas');
    this._canvas2d.width = Common.game.canvas.WIDTH;
    this._canvas2d.height = Common.game.canvas.HEIGHT;

    // Context.
    this._context = this._canvas2d.getContext('2d');

    // TEST: DYN_OUT:
    this._dynOutline_c2d = document.createElement('canvas');
    this._dynOutline_c2d.width = Common.game.canvas.WIDTH;
    this._dynOutline_c2d.height = Common.game.canvas.HEIGHT;

    this._dynOutlineContext = this._dynOutline_c2d.getContext('2d');
    this._dynOutlineContext.fillStyle = 'rgba(0, 0, 0, 0)';
    this._dynOutlineContext.fillRect(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    this._dynOutlineLayerData = this._dynOutlineContext.getImageData(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    // Tools.
    // Pencil.
    this._pencil = new Pencil();
    this._pencil.init(this);
    // Brush.
    this._brush = new Brush();
    this._brush.init(this);
    // Spray.
    this._spray = new Spray();
    this._spray.init(this);
    // Stamp.
    this._stamp = new Stamp();
    this._stamp.init(this);
    // Ink pot.
    this._inkPot = new InkPot();
    this._inkPot.init(this);
    // Eraser.
    this._eraser = new Eraser();
    this._eraser.init(this, Common.game.canvas.fillLayer);

    // Layer.
    this._layerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._canvas2d));
    this._layerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._layerSprite.interactive = true;
    this._layerSprite.mousedown = this._layerSprite.touchstart = this._onDrawLayer_MouseDown.bind(this);
    this._layerSprite.mousemove = this._layerSprite.touchmove = this._onDrawLayer_MouseMove.bind(this);
    this._layerSprite.mouseup = this._layerSprite.touchend = this._onDrawLayer_MouseUp.bind(this);
    this._layerSprite.mouseupoutside = this._layerSprite.touchendoutside = this._onDrawLayer_MouseOut.bind(this);
    this.addChild(this._layerSprite);

    // Default tool.
    this._onDrawMode_Changed(CommonGame.TOOL.PENCIL);

    // Listen to HUD controls.
    Common.game.hud.signals.onDrawModeChanged.add(this._onDrawMode_Changed, this);
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

DrawLayer.prototype.setEnabled = function (isEnabled) {
    this._layerSprite.interactive = isEnabled;
};

DrawLayer.prototype.update = function () {
    // Vfx.
    this._drawPS.update(P3.Timestep.deltaTime);

    if (this._drawingTool != this._spray
        && this._drawPS.emit
        && this._lastInputLocalPosition.x == this._updateInputLocalPosition.x
        && this._lastInputLocalPosition.y == this._updateInputLocalPosition.y)
        this._drawPS.emit = false;

    this._updateInputLocalPosition.x = this._lastInputLocalPosition.x;
    this._updateInputLocalPosition.y = this._lastInputLocalPosition.y;
};

DrawLayer.prototype.setLayerData = function (data, dynOutlineData) {
    this._context.putImageData(data, 0, 0);

    this._dynOutlineLayerData = dynOutlineData;
    this._dynOutlineContext.putImageData(dynOutlineData, 0, 0);


    this._layerSprite.texture.update();
};

DrawLayer.prototype.clear = function () {
    this._dynOutlineContext.clearRect(0, 0, this._canvas2d.width, this._canvas2d.height);
    this._dynOutlineLayerData = this._dynOutlineContext.getImageData(0, 0, this._dynOutline_c2d.width, this._dynOutline_c2d.height);

    this._context.clearRect(0, 0, this._canvas2d.width, this._canvas2d.height);

    this._layerSprite.texture.update();
};


//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

DrawLayer.prototype.onContext_Changed = function () {
    // Tutorial.
    Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.CANVAS_DRAWN);

    this._layerSprite.texture.update();
};

DrawLayer.prototype._onDrawLayer_MouseDown = function (mouseData) {
    //console.log( "mousedown" );

    // Undo manager.
    Common.game.undoManager.save();


    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._layerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + Common.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + Common.game.canvas.HEIGHT * 0.5);

    this._lastInputLocalPosition = new PIXI.Point(ctxCoordPosition.x, ctxCoordPosition.y);
    this._state = this.STATE.DRAWING;

    this._drawingTool.onDrawBegan(ctxCoordPosition);


    // Vfx.
    if (this._drawingTool == this._stamp
        || this._drawingTool == this._spray) {
        this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
        this._drawPS.emit = true;
    }
};

DrawLayer.prototype._onDrawLayer_MouseMove = function (mouseData) {
    //console.log( "mousemove" );

    if (this._state != this.STATE.DRAWING) return;

    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._layerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + Common.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + Common.game.canvas.HEIGHT * 0.5);

    this._drawingTool.onDrawMoved(this._lastInputLocalPosition, ctxCoordPosition);

    this._lastInputLocalPosition.x = ctxCoordPosition.x;
    this._lastInputLocalPosition.y = ctxCoordPosition.y;

    // Vfx.
    if (this._drawingTool != this._stamp) {
        if (!this._drawPS.emit) {
            this._drawPS.resetPositionTracking();
            this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
            this._drawPS.emit = true;
        }
        else
            this._drawPS.updateSpawnPos(localCoordsPosition.x, localCoordsPosition.y);
    }
};

DrawLayer.prototype._onDrawLayer_MouseUp = function (mouseData) {
    //console.log( "mouseup" );

    if (this._state == this.STATE.DRAWING) {
        this._drawingTool.onDrawEnded();

        this._state = this.STATE.IDLE;

        // Vfx.
        if (this._drawingTool != this._stamp)
            this._drawPS.emit = false;
    }
};

DrawLayer.prototype._onDrawLayer_MouseOut = function (mouseData) {
    //console.log( "mouseout" );

    if (this._state == this.STATE.DRAWING) {
        this._drawingTool.onDrawEnded();

        this._state = this.STATE.IDLE;
    }

    // Vfx.
    this._drawPS.emit = false;
};

DrawLayer.prototype._onThickness_Changed = function (selection) {
    this._thickness = this.BASE_LINE_THICKNESS * ( selection + 1 );
};

DrawLayer.prototype._onColour_Changed = function (selection) {
    if (this._drawingTool == this._pencil
        || this._drawingTool == this._brush
        || this._drawingTool == this._spray
        || this._drawingTool == this._inkPot) {
        var rgbColour = {r: 255, g: 255, b: 255};

        if (this._drawingTool.paletteItem.indexOf("#") == 0)
            rgbColour = Common.hexToRgb(this._drawingTool.paletteItem);

        this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
        this._drawPS.endColor = this._drawPS.startColor;
    }
};

DrawLayer.prototype._onDrawMode_Changed = function (selection) {
    var rgbColour = {r: 255, g: 255, b: 255};

    switch (selection) {
        case CommonGame.TOOL.PENCIL:
        {
            this._drawingTool = this._pencil;

            // Vfx.
            if (this._drawingTool.paletteItem.indexOf("#") == 0)
                rgbColour = Common.hexToRgb(this._drawingTool.paletteItem);
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_draw")], Common.assets.getJSON("pencil_ps"));
            this._drawPS.emitterLifetime = -1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_pencil_select_00" );
            break;
        }

        case CommonGame.TOOL.BRUSH:
        {
            this._drawingTool = this._brush;

            // Vfx.
            if (this._drawingTool.paletteItem.indexOf("#") == 0)
                rgbColour = Common.hexToRgb(this._drawingTool.paletteItem);
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_paintbrush")], Common.assets.getJSON("brush_ps"));
            this._drawPS.emitterLifetime = -1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_paintbrush_select_00" );
            break;
        }

        case CommonGame.TOOL.SPRAY:
        {
            this._drawingTool = this._spray;

            // Vfx.
            if (this._drawingTool.paletteItem.indexOf("#") == 0)
                rgbColour = Common.hexToRgb(this._drawingTool.paletteItem);
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_spray")], Common.assets.getJSON("spray_ps"));
            this._drawPS.emitterLifetime = -1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_spraycan_select_00" );
            break;
        }

        case CommonGame.TOOL.STAMP:
        {
            this._drawingTool = this._stamp;

            // Vfx.
            rgbColour = Common.hexToRgb("#ffe400");
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_stamp")], Common.assets.getJSON("stamp_ps"));
            this._drawPS.emitterLifetime = 0.1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_stamps_select_00" );
            break;
        }

        case CommonGame.TOOL.INK_POT:
        {
            this._drawingTool = this._inkPot;

            // Vfx.
            if (this._drawingTool.paletteItem.indexOf("#") == 0)
                rgbColour = Common.hexToRgb(this._drawingTool.paletteItem);
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_ink_splatter")], Common.assets.getJSON("ink_splatter_ps"));
            this._drawPS.emitterLifetime = -1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_inkpot_select_00" );
            break;
        }

        case CommonGame.TOOL.ERASER:
        {
            this._drawingTool = this._eraser;

            // Vfx.
            rgbColour = Common.hexToRgb("#fd93bd");
            this._drawPS = new PIXI.particles.Emitter(this, [Common.assets.getTexture("particle_erase")], Common.assets.getJSON("eraser_ps"));
            this._drawPS.emitterLifetime = -1;

            // Sfx.
            //Common.audio.playSound( "sfx_tool_eraser_select_00" );
            break;
        }
    }

    this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
    this._drawPS.endColor = this._drawPS.startColor;
    this._drawPS.emit = false;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    DrawLayer.prototype,
    "context",
    {
        get: function () {
            return this._context;
        }
    });

Object.defineProperty(
    DrawLayer.prototype,
    "dynOutlineContext",
    {
        get: function () {
            return this._dynOutlineContext;
        }
    });

Object.defineProperty(
    DrawLayer.prototype,
    "state",
    {
        get: function () {
            return this._state;
        }
    });

Object.defineProperty(
    DrawLayer.prototype,
    "drawingTool",
    {
        get: function () {
            return this._drawingTool;
        }
    });

Object.defineProperty(
    DrawLayer.prototype,
    "dynOutlineData",
    {
        get: function () {
            return this._dynOutlineLayerData;
        },
        set: function (a) {
            return this._dynOutlineLayerData = a;
        }
    });